export default Object.freeze({
  REDSHIFT: 'redshift',
  SNOWFLAKE: 'snowflake',
  DATABRICKS: 'databricks',
  POSTGRES: 'postgres_sink',
  MYSQL: 'mysql_sink',
  SQLSERVER: 'sqlserver_sink',
  S3: 's3',
  PINTEREST: 'pinterest',
  BIGQUERY: 'bigquery',
  TEST: 'test',
});
